import { TTV_CONVERSION_COMPLETIONS_STORAGE_KEY } from "@/app/(application)/(normal)/create/ttvConversionCompletions/constants";

// Completion observations share the tab's transfer-correlation lifetime. Session storage survives reload; document memory prevents route remounts from recounting when storage is unavailable.
const observedCompletions = new Set<string>();

export const claimTtvConversionCompletion = (conversionId: string): boolean => {
  let storedCount = 0;
  let canPersist = true;
  try {
    const stored: unknown = JSON.parse(
      sessionStorage.getItem(TTV_CONVERSION_COMPLETIONS_STORAGE_KEY) ?? "[]"
    );
    const storedIds = new Set<string>(
      Array.isArray(stored) ?
        stored.filter((id): id is string => typeof id === "string")
      : []
    );
    storedCount = storedIds.size;
    storedIds.forEach((id) => observedCompletions.add(id));
  } catch (error) {
    console.error("Could not read observed TTV conversion completions", error);
    // A failed read must not overwrite observations that may still exist in storage.
    canPersist = false;
  }
  const isFirstObservation = !observedCompletions.has(conversionId);
  observedCompletions.add(conversionId);
  if (canPersist && observedCompletions.size !== storedCount) {
    try {
      sessionStorage.setItem(
        TTV_CONVERSION_COMPLETIONS_STORAGE_KEY,
        JSON.stringify([...observedCompletions])
      );
    } catch (error) {
      console.error(
        "Could not remember observed TTV conversion completions",
        error
      );
    }
  }
  return isFirstObservation;
};
